import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { RcAppComponent } from './app/pages/app.component';

bootstrapApplication(RcAppComponent, appConfig).catch((err) =>
  console.error(err),
);
